import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCard from '../shared/SectionCard'
import FileUploadField from '../shared/FileUploadField'
import './style.css'

const EditCertifications = ({ formHandler, providerInfo }) => {
    const { t } = useTranslation()

    return (
        <SectionCard 
            title={t("certifications")} 
            icon="mdi:certificate-outline"
            className="edit-certifications"
        >
            <div className="edit-form-grid">
                <FileUploadField
                    formHandler={formHandler}
                    name="certifications"
                    label={t("upload-certifications")}
                    accept="image/*,.pdf"
                    multiple
                    maxFiles={10}
                    helperText={t("certifications-upload-hint")}
                />
            </div>
        </SectionCard>
    )
}

export default EditCertifications

